import { Rocket, Sparkles } from "lucide-react";

export default function ComingSoon() {
  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center p-8">
      <div className="text-center max-w-2xl mx-auto">
        <div className="relative inline-block mb-8">
          <div className="w-32 h-32 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-3xl flex items-center justify-center shadow-2xl">
            <Rocket className="w-16 h-16 text-white" />
          </div>
          <div className="absolute -top-2 -right-2">
            <Sparkles className="w-8 h-8 text-yellow-400 animate-pulse" />
          </div>
        </div>
        
        <h1 className="text-5xl font-bold text-slate-800 mb-4">
          Dashboard Coming Soon
        </h1>
        
        <p className="text-lg text-slate-600 mb-8">
          We're building something amazing! In the meantime, you can configure your settings from the sidebar menu.
        </p>
        
        <div className="inline-flex items-center gap-2 px-6 py-3 bg-indigo-50 border border-indigo-200 rounded-full text-indigo-700 font-medium">
          <Sparkles className="w-5 h-5" />
          Stay tuned for updates
        </div>
      </div>
    </div>
  );
}